import { AccountMapComponent } from "@rubbl-azure-maps";
import { AuthGuard } from "@rubbl-core";
import { LayoutComponent } from "app/layout/layout.component";
import { EcomLegacyRedirectComponent, EcomLegacyRedirectGuard, legacyEcomMatcher } from "./ecom/ecom-legacy-redirect.guard";

export const routes = [
  {
    path: "public/inspection/:id",
    loadChildren: () => import("./inspection/public-inspection.module").then(m => m.PublicInspectionModule),
    data: {
      pageTitle: "Inspection",
      public: true,
    },
  },
  {
    path: "map",
    canActivate: [AuthGuard],
    component: AccountMapComponent,
    data: { login: true },
  },
  {
    path: "",
    component: LayoutComponent,
    canActivate: [AuthGuard],
    data: { login: true },
    children: [
      { matcher: legacyEcomMatcher, component: EcomLegacyRedirectComponent, canActivate: [EcomLegacyRedirectGuard] },
      { path: "ecom", loadChildren: () => import("./ecom/ecom.module").then(m => m.EcomModule), data: { pageTitle: "Ecom" } },
      {
        path: "order",
        loadChildren: () => import("./order/order.module").then(m => m.OrderModule),
        data: {
          pageTitle: "Orders",
        },
      },
      {
        path: "account",
        loadChildren: () => import("./account/account.module").then(m => m.AccountModule),
        data: {
          pageTitle: "Account",
        },
      },
      {
        path: "inventory",
        loadChildren: () => import("./inventory/inventory.module").then(m => m.InventoryModule),
        data: {
          pageTitle: "Inventory",
        },
      },

      {
        path: "inspection",
        loadChildren: () => import("./inspection/inspection.module").then(m => m.InspectionModule),
        data: {
          pageTitle: "Inspections",
        },
      },

      {
        path: "billing",
        loadChildren: () => import("./billing/billing.module").then(m => m.BillingModule),
        data: {
          pageTitle: "Billing",
        },
      },
      {
        path: "dashboard",
        loadChildren: () => import("./dashboard/dashboard.module").then(m => m.DashboardModule),
        data: {
          pageTitle: "Dashboard",
        },
      },
      {
        path: "platform",
        loadChildren: () => import("./platform/platform.module").then(m => m.PlatformModule),
      },
      {
        path: "onboarding",
        loadChildren: () => import("./onboarding/onboarding.module").then(m => m.OnboardingModule),
        data: {
          pageTitle: "Onboarding",
        },
      },
      {
        path: "coupon",
        loadChildren: () => import("./coupon/coupon.module").then(m => m.CouponModule),
        data: {
          pageTitle: "Coupons",
        },
      },
      {
        path: "connect",
        loadChildren: () => import("./connect/connect.module").then(m => m.ConnectModule),
        data: {
          pageTitle: "Rubbl Connect",
        },
      },
      // must be last
      {
        path: "",
        redirectTo: "order",
        pathMatch: "full",
      },
    ],
  },

  // Not found
  { path: "**", redirectTo: "", canActivate: [AuthGuard], data: { login: true } },
];
